import React from 'react';
import { type FieldValues, type Path, useController, useFormContext } from 'react-hook-form';
import FormErrorComponent from 'components/FormError';

type RootPath<T extends FieldValues> = `root.${string}` & Path<T>;

interface FormErrorProps<T extends FieldValues> {
  name: RootPath<T>;
}

const FormError = <T extends FieldValues>({ name }: FormErrorProps<T>) => {
  const { control } = useFormContext<T>();
  const {
    fieldState: { error }
  } = useController({ name, control });

  return <FormErrorComponent errorMessage={error?.message} />;
};

export default FormError;
